export type StoreFeatureIconId =
  | 'collection'
  | 'customization'
  | 'consultant'
  | 'certification'
  | 'refund'
  | 'exchange';

export type StoreFeatureSectionVariant = 'special' | 'promise';

export interface StoreFeatureItem {
  id: StoreFeatureIconId;
  titleLines: string[];
  descriptionLines: string[];
}

export interface StoreFeatureSectionData {
  variant: StoreFeatureSectionVariant;
  title: string;
  items: StoreFeatureItem[];
}

export const STORE_WHATS_SPECIAL_ITEMS: StoreFeatureItem[] = [
  {
    id: 'collection',
    titleLines: ['Designer', 'Collections'],
    descriptionLines: ['Monthly launches of unique and contemporary designer collections'],
  },
  {
    id: 'customization',
    titleLines: ['Customization', 'Options'],
    descriptionLines: [
      'Customize the gold karat, gold colour, diamond carat and size on jewellery of your choice',
    ],
  },
  {
    id: 'consultant',
    titleLines: ['Jewellery', 'Consultants'],
    descriptionLines: [
      'Our experienced consultants will just assist you with selection. No compulsion to buy!',
    ],
  },
];

export const STORE_PROMISE_ITEMS: StoreFeatureItem[] = [
  {
    id: 'certification',
    titleLines: ['Certified', 'Jewellery'],
    descriptionLines: ['BIS Hallmark Gold and', 'IGI & GIA Certified Diamonds'],
  },
  {
    id: 'refund',
    titleLines: ['100%', 'Refund'],
    descriptionLines: ['Not Satisfied?', 'Return within 30 days'],
  },
  {
    id: 'exchange',
    titleLines: ['Lifetime Exchange', '& Buyback'],
    descriptionLines: ['Exchange or avail', 'buy back at best rates'],
  },
];

export const STORE_FEATURE_SECTIONS: StoreFeatureSectionData[] = [
  {
    variant: 'special',
    title: "What's Special",
    items: STORE_WHATS_SPECIAL_ITEMS,
  },
  {
    variant: 'promise',
    title: 'BlueStone Promise',
    items: STORE_PROMISE_ITEMS,
  },
];
